var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.user.isAdmin
    ? _c("div", [
        _c("div", { staticClass: "flex flex-wrap flex-col md:flex-row" }, [
          _c("div", { staticClass: "w-full md:w-1/2" }, [
            _c(
              "h1",
              { staticClass: "mt-2 mb-4 md:mb-0 font-sans text-n-gray-dark" },
              [
                _vm.user.isAdmin
                  ? [_vm._v("All Events")]
                  : [_vm._v("Your Events")],
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "w-full md:w-1/2 md:text-right mb-5 md:mb-0" },
            [
              _c(
                "router-link",
                { staticClass: "button mb-2", attrs: { to: "/events/create" } },
                [_vm._v("Create Event")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex flex-wrap" }, [
          _c("div", { staticClass: "flex-1 mb-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filters.keyword,
                  expression: "filters.keyword",
                },
              ],
              staticClass: "mb-4 search",
              attrs: {
                type: "text",
                placeholder:
                  "Search title, creator first name, creator last name, organization name",
              },
              domProps: { value: _vm.filters.keyword },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.searchEvents.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.filters, "keyword", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-full md:w-1/5" }, [
            _c(
              "button",
              {
                staticClass: "button mb-2",
                attrs: { href: "/events/create" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.searchEvents.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Search")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-full md:w-1/5" }, [
            _c(
              "button",
              {
                staticClass: "button mb-2",
                attrs: { href: "/events/create" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.clearSearch.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Clear")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "responsive-table" }, [
          _c(
            "table",
            { staticClass: "w-full md:table-fixed" },
            [
              _c("thead", [
                _c("tr", [
                  _c("th", { staticClass: "md:w-1/6" }, [_vm._v("Title")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "md:w-1/6" }, [_vm._v("Festival")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "md:w-1/6" }, [
                    _vm._v("Creating User, Organization"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "md:w-1/6",
                      on: {
                        click: function ($event) {
                          return _vm.setFilterDate("created")
                        },
                      },
                    },
                    [
                      _vm._v("Created "),
                      _c(
                        "svg",
                        {
                          staticClass: "w-4",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            version: "1.1",
                            viewBox: "0 0 25.5 20",
                          },
                        },
                        [
                          _c("polygon", {
                            attrs: {
                              fill: "white",
                              points: "0 0 25 0 12.5 20 0 0",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "md:w-1/6",
                      on: {
                        click: function ($event) {
                          return _vm.setFilterDate("start")
                        },
                      },
                    },
                    [
                      _vm._v("Event Date "),
                      _c(
                        "svg",
                        {
                          staticClass: "w-4",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            version: "1.1",
                            viewBox: "0 0 25.5 20",
                          },
                        },
                        [
                          _c("polygon", {
                            attrs: {
                              fill: "white",
                              points: "0 0 25 0 12.5 20 0 0",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("th", { staticClass: "text-white md:w-1/6" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filters.status,
                            expression: "filters.status",
                          },
                        ],
                        staticClass: "text-white fill-current",
                        attrs: { name: "status" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.filters,
                              "status",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Status (All)"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "new" } }, [
                          _vm._v("Draft"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "review" } }, [
                          _vm._v("In Review"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "published" } }, [
                          _vm._v("Published"),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              this.isSearching &&
              this.searchedEvents &&
              this.searchedEvents.length < 1
                ? _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "text-center font-bold",
                        attrs: { colspan: "5" },
                      },
                      [_vm._v("No search results")]
                    ),
                  ])
                : _vm._l(_vm.filteredEvents, function (event) {
                    return _c("event-item", {
                      key: event.id,
                      attrs: { event: event },
                    })
                  }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex mt-8" }, [
          _c("div", { staticClass: "w-1/2" }, [
            _c(
              "button",
              {
                staticClass: "mt-2",
                class: {
                  "opacity-50 cursor-not-allowed": _vm.currentPage === 1,
                },
                attrs: { disabled: _vm.currentPage === 1 },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.previous.apply(null, arguments)
                  },
                },
              },
              [_vm._v("<< Previous")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-1/2 text-right" }, [
            _c(
              "button",
              {
                staticClass: "mt-2",
                class: {
                  "opacity-50 cursor-not-allowed":
                    _vm.currentPage === _vm.totalPages,
                },
                attrs: { disabled: _vm.currentPage === _vm.totalPages },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.next.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Next >>")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt-6 text-center" },
          [
            _c(
              "router-link",
              { staticClass: "button mb-2", attrs: { to: "/events/archive" } },
              [_vm._v("\n            View Archived Events\n        ")]
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }